import { effect, EventEmitter, Injectable, signal } from '@angular/core';

export interface PERIOD_FILTER {
  start_date: string,
  end_date: string
}
@Injectable({
  providedIn: 'root',
})
export class EmitterService {
  // Signal que controla todos dados do cenario.
  private _allScenaryData = signal<{}>(JSON.parse(sessionStorage.getItem('allScenaryData')) || {})
  public allScenaryData = this._allScenaryData.asReadonly();

  // Signal que controla o estado do nome do cenario
  private _currentScenarioName = signal<string>(localStorage.getItem('currentScenarioName') || '')
  public currentScenarioName = this._currentScenarioName.asReadonly();

  // Signal que controla o tipo do cenario, para verificação em telas
  private _currentTypeScenario = signal<string>(localStorage.getItem('currentTypeScenario') || '')
  public currentTypeScenario = this._currentTypeScenario.asReadonly();

  // Signal que controla se o cenario foi otimizado ou não
  private _wasOtimizated = signal<boolean>(JSON.parse(sessionStorage.getItem('wasOtimizated')) || false)
  public wasOtimizated = this._wasOtimizated.asReadonly();

  // Signal que controla se o usuario está iniciando com proxima campanha (OBS: So é util para cenarios L3)
  private _isPreviouCampaing = signal<boolean>(JSON.parse(sessionStorage.getItem('isPreviouCampaing')) || false)
  public isPreviouCampaing = this._isPreviouCampaing.asReadonly();

  private _periodFilterResult = signal<PERIOD_FILTER>(JSON.parse(sessionStorage.getItem('periodResult')) || null)
  public periodFilterResult = this._periodFilterResult.asReadonly();

  // Signal para pegar a data de estoque
  private _deltaHistory = signal<string>(JSON.parse(sessionStorage.getItem('deltaHistory')) || null)
  public deltaHistory = this._deltaHistory.asReadonly();

  constructor() {
    effect(() => {
      localStorage.setItem('currentScenarioName', this._currentScenarioName());
    })

    effect(() => {
      localStorage.setItem('currentTypeScenario', this._currentTypeScenario());
    })

    effect(() => {
      sessionStorage.setItem('wasOtimizated', JSON.stringify(this._wasOtimizated()))
    })

    effect(() => {
      sessionStorage.setItem('isPreviouCampaing', JSON.stringify(this._isPreviouCampaing()))
    })

    effect(() => {
      sessionStorage.setItem('allScenaryData', JSON.stringify(this._allScenaryData()))
    })

    effect(() => {
      sessionStorage.setItem('periodResult', JSON.stringify(this._periodFilterResult()))
    })

    effect(() => {
      sessionStorage.setItem('deltaHistory', JSON.stringify(this._deltaHistory()))
    })
  }

  updateScenarioName(newName: string) {
    this._currentScenarioName.set(newName)
  }

  updateOtimizationStatus(status: boolean) {
    this._wasOtimizated.set(status)
  }

  updateScenarioType(type: string) {
    this._currentTypeScenario.set(type)
  }

  updatePreviousCampaign(isPrevious: boolean) {
    this._isPreviouCampaing.set(isPrevious)
  }

  updateAllScenaryData(scenarioData) {
    this._allScenaryData.set(scenarioData)
  }

  updateFilterPeriod(startDate: string, endDate: string) {
    this._periodFilterResult.set({start_date: startDate, end_date: endDate})
  }

  updateDeltaHistory(text: string) {
    this._deltaHistory.set(text)
  }
  
}